import { ShieldX, ArrowLeft, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-6 px-4">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-6">
            <ShieldX className="h-16 w-16 text-destructive" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-4xl font-bold tracking-tight">403</h1>
          <h2 className="text-xl font-semibold text-muted-foreground">
            접근 권한이 없습니다
          </h2>
        </div>

        <p className="text-muted-foreground max-w-md mx-auto">
          이 페이지에 접근할 수 있는 권한이 없습니다.
          <br />
          관리자에게 권한을 요청하거나 다른 페이지로 이동해주세요.
        </p>

        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            뒤로 가기
          </Button>
          <Button onClick={() => navigate("/dashboard")}>
            <Home className="mr-2 h-4 w-4" />
            대시보드로 이동
          </Button>
        </div>
      </div>
    </div>
  );
}
